import store from "../Redux/Store";
export const checkToShowBanner = () => {
  const showBanner = store.getState().staffManagementReducer.staffMemberData?.banner_info?.text;
  return !!showBanner;
};
